import classNames from "classnames";
import DocumentIllustration from "../../styles/illustrations/DocumentIllustration.png";
import { SurveyInfo } from "../SurveyInfo/SurveyInfo";
import { Typography } from "../ui/Typography/Typography";
import "./SurveyInvalid.scss";

export interface SurveyInvalidProps {
  className?: string;
  title: string;
  info: string;
}

export const SurveyInvalid = ({
  className,
  title,
  info,
}: SurveyInvalidProps) => {
  const classes = classNames("SurveyInvalid", className);

  return (
    <div className={classes}>
      <div>
        <img
          className="SurveyInvalid__img"
          src={DocumentIllustration}
          alt="invalid survey"
        />
        <Typography
          className="SurveyInvalid__title"
          tagVariant="h1"
          desktop="display2"
          mobile="display2"
        >
          {title}
        </Typography>
        <Typography
          className="SurveyInvalid__info"
          tagVariant="p"
          desktop="body1"
          mobile="body1"
          weight="regular"
        >
          {info}
        </Typography>
      </div>
      <SurveyInfo />
    </div>
  );
};
